// extracted by mini-css-extract-plugin
export default {"container":"P4-z","list":"Q4-z"};